/* esm.sh - unhead@2.1.12/dist/shared/unhead.0eF0fa-Y */
export * from "/*unhead@2.1.12/esnext/dist/shared/unhead.0eF0fa-Y.mjs";
